import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';   // 👈 Yeh import karo
import { allapiAction } from '../../Redux/common/action';
import FooterNew from './FooterNew';

function NewHeader() {
  const toggleSidebar = () => {
    document.body.classList.toggle('collapsed');
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();   // 👈 Yaha call karo hook ko

  useEffect(() => {
    dispatch(allapiAction.getprofile());
    return () => {};
  }, []);


  useEffect(() => {
    document.body.classList.add('collapsed'); // 👈 This keeps the sidebar closed initially
    // ...
  }, []);

  const hendletoLogout = async () => {
    window?.localStorage.removeItem("access_token");
    window?.localStorage.removeItem("access_token_vendor");
    window?.localStorage.removeItem("access_user");
    localStorage.clear();
    navigate("/login");    // 👈 Ab yeh sahi tarike se page change karega
  };

  return (
    <div>
      <div className="header">
        <div className="toggle-btn" onClick={toggleSidebar}>☰</div>
        {/* <div >  <a href="/"><img src="img/logo.png" alt="" style={{ width: "150px" }}  /></a></div> */}
        <button className="btn btn-primary btn-sm" onClick={hendletoLogout}>
  Logout
</button>

<style jsx="true">{`
  .btn {
    padding: 10px 20px;
    font-size: 16px;
    border-radius: 30px; /* Rounded corners */
    border: none;
    background: linear-gradient(45deg, #3498db, #1abc9c);
    color: #fff;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 5px 15px rgba(52, 152, 219, 0.3); /* Soft shadow */
  }

  .btn:hover {
    background: linear-gradient(45deg, #1abc9c, #3498db);
    transform: translateY(-2px); /* Lift effect on hover */
    box-shadow: 0 10px 20px rgba(52, 152, 219, 0.4); /* Enhanced shadow on hover */
  }

  // .btn:active {
  //   transform: translateY(0px); /* Button presses back to normal */
  //   box-shadow: 0 5px 15px rgba(52, 152, 219, 0.3); /* Normal shadow */
  // }
`}</style>

      </div>
      <style jsx="true">{`
        // body {
        //   margin: 0;
        //   font-family: 'Poppins', sans-serif;
        //   background: #f5f5f5;
        // }
        .sidebar {
          height: 100vh;
          width: 250px;
          position: fixed;
          top: 0;
          left: 0;
          background-color: #1c0f5c;
          padding-top: 70px;
          transition: all 0.3s;
          overflow-y: auto;
        }
        .sidebar a {
          padding: 15px 20px;
          text-decoration: none;
          font-size: 18px;
          color: #fff;
          display: block;
          transition: 0.3s;
        }
        .sidebar a:hover {
          background-color: #2d1b80;
        }
        .header {
          background-color: #1c0f5c;
          height: 60px;
          width: 100%;
          position: fixed;
          top: 0;
          left: 0;
          z-index: 999;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 20px;
          color: #fff;
        }
        .toggle-btn {
          font-size: 24px;
          cursor: pointer;
          color: #fff;
        }
        .main {
          margin-left: 250px;
          padding: 80px 20px 20px 20px;
          transition: all 0.3s;
        }
        .collapsed .sidebar {
          width: 0;
        }
        .collapsed .main {
          margin-left: 0;
        }
        .profile-card {
          background: radial-gradient(ellipse at center, #b5e2e5 0, #49c8d1 100%);
          padding: 20px;
          border-radius: 15px;
        //   margin-top: 20px;
          margin-bottom: 20px;
          text-align: center;
        }
        .copy-btn {
          background: linear-gradient(45deg, #3498db, #1abc9c);
          color: #fff;
          border: none;
          margin-top: 10px;
          padding: 8px 20px;
          border-radius: 20px;
          font-size: 14px;
          cursor: pointer;
          transition: background 0.3s;
        }
        .copy-btn:hover {
          background: linear-gradient(45deg, #1abc9c, #3498db);
        }
        .slider {
          margin-bottom: 20px;
        }
        .slider img {
          width: 100%;
          {/* height: 250px; */}
          object-fit: cover;
          border-radius: 10px;
        }
        .info-cards {
          margin-top: 20px;
        }
        .card-box {
          background: #fff;
          padding: 20px;
          border-radius: 15px;
          text-align: center;
          box-shadow: 0 5px 25px rgba(41, 128, 185, 0.15);
          margin-bottom: 20px;
        }
        .marquee-wrapper {
          margin: 20px 0;
          font-weight: bold;
          color: #1c0f5c;
          font-size: 18px;
        }
        @media (min-width: 992px) {
          .sidebar {
            position: fixed;
            top: 0;
            left: 0;
          }
          .main {
            margin-left: 250px;
          }
        }
      `}</style>
      {/* Style code same rehne do */}
    
      <FooterNew />
    </div>
  )
}

export default NewHeader
